











































































import { defineComponent, reactive, toRefs, onMounted, watch } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import { SumupListCondition, SumupGroup } from "../../modules/teacher/ExamResultNotificationList"


export interface Data {
  condition: SumupListCondition
  sumupGroups: SumupGroup[]
  fields: any[]
  totalCount: number
  isAllCheckedDelete: boolean
  errors: string[]
  isShow: boolean
  progress: string
  isDispProgress: boolean
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){
    
    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: context.root.$store.state.sumupListCondition,
      sumupGroups: new Array<SumupGroup>(),
      fields: [
        {key: "id", label: "通知ID", sortable: true, class: 'text-center b-table-th-td'},
        {key: "exec_date", label: "実施日", sortable: true, class: 'text-center b-table-th-td'},
        {key: "name", label: "試験名", sortable: true, class: 'text-center b-table-th-td'},
      ],
      totalCount: 0,
      isAllCheckedDelete: false,
      errors: [],
      progress: "0.0",
      isDispProgress: false,
      isShow: false
    });

    /******************************
     * 検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * 検索API
     ******************************/

    const search = async () => {
      
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/exam_result_notification_list?${Common.BuildQuery(state.condition, 'search_condtion')}`).then(response => {
        state.sumupGroups = response.data.sumup_groups.map((x: any) => new SumupGroup(x));
        context.root.$store.commit("setSumupListCondition", state.condition);
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 実施日を画面表示文言にコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('M月D日') : "-";
    };

    /******************************
     * クリアボタン押下
     ******************************/

    const clearCondition = () => {
      state.condition = new SumupListCondition();
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      context.root.$store.commit("setSumupListCondition", state.condition);
    };

    /******************************
     * マスタ追加ボタン押下
     ******************************/

    const addSumupGroupClick = () => {
      context.root.$router.push('/teacher_site/exam_result_notification_edit/new').catch(err => {});
    };

    /******************************
     * 設定ボタン押下
     ******************************/

    const sumupEditClick = (id: number) => {
      context.root.$router.push(`/teacher_site/exam_result_notification_edit/${id}`).catch(err => {});
    };

    /******************************
     * 削除列ヘッダーCheckBoxの監視
     ******************************/

    watch(() => state.isAllCheckedDelete, (newVal, oldVal) => {
      state.sumupGroups.forEach(x => x.isSelected = newVal);
    });

    /******************************
     * 削除アイコン押下
     ******************************/

    const sumupGruoupDelete = async () => {

      state.errors = []

      const ids = state.sumupGroups.filter(x => x.isSelected).map(x => x.id);

      if(ids.length == 0){
        state.errors.push("削除対象が選択されていません。");
      }

      if (!window.confirm('マスタを削除します。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/exam_result_notification_list/sumup_groups_destroy`, {ids: ids}).then(response => {
        alert("処理が完了しました。");
        search();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * mounted キャッシュしている検索条件で検索実行
     ******************************/
    
    onMounted(async () => {
      state.condition = context.root.$store.state.sumupListCondition;
      context.root.$store.commit("setSheetType", Common.SheetTypeEnum.Practice);
      await search();
      state.isShow = true;
    });

    return {
      ...toRefs(state),
      search,
      searchClick,
      convertExecDate,
      clearCondition,
      changePage,
      addSumupGroupClick,
      sumupEditClick,
      sumupGruoupDelete,
    }
  }
});
